// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__aqah4","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1Y1bc","obliqueLine":"membershipbadge_obliqueLine__2p2DY"};